import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export default function CTABanner() {
  return (
    <section className="ye-cta-banner" data-testid="cta-banner">
      <div className="ye-container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 28, flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 380px" }}>
          <h2 className="ye-display ye-h2" style={{ margin: "0 0 10px" }}>Planning a solar or BESS package?</h2>
          <p style={{ margin: 0, color: "rgba(255,255,255,0.85)", fontSize: 17 }}>
            Get a mobilisation-ready quote. Our team responds within 48 hours.
          </p>
        </div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link to="/contact" className="ye-btn ye-btn-primary" data-testid="cta-banner-quote">Get a Quote</Link>
          <a href="tel:+917689912984" className="ye-btn ye-btn-outline-white" data-testid="cta-banner-call"><Phone size={16} /> Call +91 76899 12984</a>
        </div>
      </div>
    </section>
  );
}
